module.exports = __webpack_public_path__ + "4-f7cb1533.png";